import { Component } from '@angular/core';
import { SUPPORT_EMAIL } from '../../../app.constants';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.page.html',
  styleUrl: '../legal/legal.page.scss'
})
export class ContactPage {
  readonly supportEmail = SUPPORT_EMAIL;
}
